import { useParams } from 'react-router';
import ServiceAndTermsPresenter from './ServiceAndTermsPresenter';
import CommonLayout from '@routes/Common/CommonLayout';

const ServiceAndTermsContainer = () => {
  const { urlParam } = useParams<any>();

  return (
    <CommonLayout gnbTabs={<></>} fullHeight>
      <ServiceAndTermsPresenter urlParam={urlParam} />
    </CommonLayout>
  );
};

export default ServiceAndTermsContainer;
